<template>
    <div class="d-flex flex-column">
        <navigator :selectedPerson="getSelectedPerson" :passedForm="getNewAgentSetup"></navigator>

        <steps :currentStep="currentStep" @changeCurrentStep="changeCurrentStep"></steps>

         <div class="new-agent flexGrow1">

            <component
                :is="stepTemplate"
                :currentStep="currentStep"
                :passedForm="getNewAgentSetup"
                :showExistingAgentSelector="isAcceptingConnection"
                @changeCurrentStep="changeCurrentStep"
                @cancelling="cancel"
                @goToNext="goToNext"
                @goToPrevious="goToPrevious"
                @readyToSave="readyToSave"
                @save="save">
            </component>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapActions, mapGetters } from 'vuex'
    import Navigator from './AgentNavigator'
    import Steps from './AgentSteps'
    import AgentForm from './AgentForm'
    import AgentCommissionsWrapper from './AgentCommissionsWrapper'

    export default {
        data: function() {
            return {
                form: {},
                stepTemplate: 'AgentForm',
                currentStep: 1,
                isAcceptingConnection: false,
                setCommissionsData: null,
            }
        },
        created: function() {
            // this.clearClonedAgent();
            this.clearSelectedPerson();

            // If we are coming from a notification when an agent invites a supplier for a protocol
            if(this.$route.params.agentId){
                this.setCommissionsData = this.$route.params
            }
            this.checkIsAcceptingInvitation()

            this.eventHub.$on('setInvitationCommissions', (data) =>{
                this.currentStep = 1

                this.stepTemplate = 'AgentForm'
                this.setCommissionsData = data
                this.checkIsAcceptingInvitation()
            });

        },
        beforeDestroy() {
            this.eventHub.$off('setInvitationCommissions');
        },
        computed: {
            ...mapGetters([
                'getSelectedPerson',
                'getClonedAgent',
                'getNewAgentSetup'
            ]),
        },
        methods: {
            ...mapActions([
                'clearSelectedPerson',
                'clearClonedAgent',
                'updateClonedAgent',
                'addAgent',
                'updateAgent',
                // 'initPeople',
                'updateNewAgentSetup',
                'getAgentInfo'
            ]),
            checkIsAcceptingInvitation: function () {
                if(this.$route.params.agentId){
                    this.isAcceptingConnection = true
                    this.getAgentInfo({
                        // supplierId: this.$route.params.supplierId, //rplace
                        // agentId: this.$route.params.agentId
                        supplierId: this.setCommissionsData.supplierId,
                        agentId: this.setCommissionsData.agentId
                    }).then(response => {
                        if(response.status == 200){
                            response.data.id = null
                            response.data.notificationId = this.$route.params.notificationId
                            this.updateNewAgentSetup(response.data) // edits existing
                        }

                    })
                }
            },
            changeCurrentStep: function(step) {
                let template = 'ProductEdit';

                this.currentStep = step;

                // this.updateClonedAgent(this.getClonedAgent);
                //this.updateNewAgentSetup(this.getClonedAgent)

                switch (step) {
                    case 1:
                        template = 'AgentForm';
                        break;

                    case 2:
                        template = 'AgentCommissionsWrapper';
                        break;

                    default:
                        break;
                }

                this.stepTemplate = template;
            },
            cancel: function() {
                this.clearSelectedPerson();
                this.$router.push({ name: 'people' });
            },
            goToNext: function(data) {
                if (!data.$invalid) {
                    this.currentStep++;

                    // We'll use clonedAgent both for create and edit
                    // so we can centralize the whole form in it

                    this.updateClonedAgent(data.form);
                    this.changeCurrentStep(this.currentStep);
                }
            },
            goToPrevious: function(data) {
                this.currentStep--;

                // We'll use clonedAgent both for create and edit
                // so we can centralize the whole form in it

                this.updateClonedAgent(data.form);
                this.changeCurrentStep(this.currentStep);
            },
            readyToSave: function(form) {
                this.updateClonedAgent(form);
            },
            save: function(invite) {
                let vm = this;
                this.addAgent({
                    sendInvite: invite
                }).then(response => {
                    vm.$router.push({ name: 'people' });
                });
            }
        },
        components: {
            Navigator,
            Steps,
            AgentForm,
            AgentCommissionsWrapper,
        }
    }
</script>

<style lang="scss" scoped>
    .new-agent {
        height: 78vh;
        overflow-x: hidden;
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// AgentNew.vue?79c31ab8